import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41c193f6")

_pushScopeId("data-v-41c193f6")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "現在のパスワード：", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "新しいパスワード：", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "新しいパスワード(確認)：", -1)
const _hoisted_6 = { class: "commands" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "変更", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModalInner,
      "onUpdate:isShow": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowModalInner = $event)),
      title: "パスワードの変更をします",
      isLeftTitle: true,
      isFitSize: true,
      onKeydown: _withKeys(_withModifiers(_ctx.change, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createVNode("input", {
              type: "password",
              maxlength: _ctx.consts.maxPasswordLength,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.oldPassword = $event))
            }, null, 8, ["maxlength"]), [
              [_vModelText, _ctx.oldPassword]
            ]),
            _createVNode(_component_ErrorMessage, {
              messages: _ctx.errorMessages.OldPassword
            }, null, 8, ["messages"]),
            _hoisted_4,
            _withDirectives(_createVNode("input", {
              type: "password",
              maxlength: _ctx.consts.maxPasswordLength,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPassword = $event))
            }, null, 8, ["maxlength"]), [
              [_vModelText, _ctx.newPassword]
            ]),
            _createVNode(_component_ErrorMessage, {
              messages: _ctx.errorMessages.NewPassword
            }, null, 8, ["messages"]),
            _hoisted_5,
            _withDirectives(_createVNode("input", {
              type: "password",
              maxlength: _ctx.consts.maxPasswordLength,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPasswordForCheck = $event))
            }, null, 8, ["maxlength"]), [
              [_vModelText, _ctx.newPasswordForCheck]
            ]),
            _createVNode(_component_ErrorMessage, {
              messages: _ctx.errorMessages.CheckPassword
            }, null, 8, ["messages"]),
            _createVNode("div", _hoisted_6, [
              _createVNode("button", {
                class: "app-button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
              }, [
                _hoisted_7
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})